import { useEffect, useState } from "react";

import { getAssignmentsClient } from "sj-ui-toolkit/src/client";

// Looks up one real assignment name for the welcome "Try an example"
// prompt: the active assignment with the most assigned users.
export function useExampleAssignment(tenant: string): string | null {
  const [assignmentName, setAssignmentName] = useState<string | null>(null);

  useEffect(() => {
    if (!tenant) return;

    let cancelled = false;

    const load = async () => {
      try {
        const { data } = await getAssignmentsClient().assignments(tenant, {
          page: 1,
          limit: 1,
          filter: "active",
          sortBy: "assigned",
          orderType: "desc",
        });
        if (cancelled) return;

        setAssignmentName(data?.assignments?.[0]?.name?.trim() || null);
      } catch (error) {
        console.error("Error fetching example assignment:", error);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [tenant]);

  return assignmentName;
}
